<template>
  <Modal id="whatsapp-share" v-slot="{ data, close }">
    <ModalShell size="md" :title="$t('cart_ready')" :close="close">
      <div class="p-4">
        <p class="text-gray-400 dark:text-gray-500">
          {{ $t("share_cart_msg") }}
        </p>

        <VyButton
          :href="data.link"
          target="_blank"
          fluid
          class="mt-4"
          icon="MdiWhatsapp"
          color="success"
          theme="solid"
          shape="rounded"
          size="lg"
          :label="$t('share')"
        />
      </div>
    </ModalShell>
  </Modal>
</template>
